export default __webpack_public_path__ + "static/media/mobile.31d3db30.png";